import{__exports as r}from"../../../../../../../_virtual/version-check.js";r.isValid=function(r){return!isNaN(r)&&r>=1&&r<=40};export{r as default};
